import { jsx } from 'react/jsx-runtime';
import { GridColumn } from './grid-column/grid-column.component.js';
import { StyledGridFixedContainer, StyledGrid } from './grid.style.js';

const Grid = (props) => {
    const { children, className = '', layout } = props;
    if (layout === 'fixed') {
        return (jsx(StyledGridFixedContainer, { children: jsx(StyledGrid, Object.assign({ className: className, layout: layout }, { children: children }), void 0) }, void 0));
    }
    return (jsx(StyledGrid, Object.assign({ className: className, layout: layout }, { children: children }), void 0));
};
Grid.Column = GridColumn;

export { Grid };
